import { render, staticRenderFns } from "./FederationPlanDetail.vue?vue&type=template&id=99b71b3e&scoped=true"
import script from "./FederationPlanDetail.vue?vue&type=script&lang=js"
export * from "./FederationPlanDetail.vue?vue&type=script&lang=js"
import style0 from "./FederationPlanDetail.vue?vue&type=style&index=0&id=99b71b3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b71b3e",
  null
  
)

export default component.exports